import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '../../../../../../assets/svg_components/ChevronRightIcon';
import OneTimePayment from '../../../../OneTimePayment';

import PaymentTabStyles from './PaymentTab.module.scss';

interface IPaymentTab {
  title: string;
  icon: any;
  link: string;
  activeLink: any;
  address: string;
  payload: any;
  type: string;
  id: string;
  loading: boolean;
}
const PaymentTab = ({
  title,
  icon,
  link,
  activeLink,
  address,
  payload,
  type,
  loading,
  id
}: IPaymentTab) => {
  const { pathname } = useLocation();

  return (
    <div className={PaymentTabStyles.wrapper}>
      <Link
        to={link}
        className={
          activeLink?.includes(pathname)
            ? PaymentTabStyles.wrapper__tabContainer
            : PaymentTabStyles.wrapper__tabContainerInactive
        }>
        <span>{icon}</span>
        <span className={PaymentTabStyles.wrapper__tabContent}>{title}</span>
        <span
          className={
            activeLink?.includes(pathname)
              ? PaymentTabStyles.wrapper__tabIcon
              : PaymentTabStyles.wrapper__tabInactiveIcon
          }>
          <ChevronRightIcon width="20" height="20" fillColor="rgba(51, 51, 51, 1)" />
        </span>
      </Link>
      {activeLink?.includes(pathname) && (
        <div className={PaymentTabStyles.wrapper__body}>
          <OneTimePayment
            type={type}
            address={address}
            payload={payload}
            loading={loading}
            id={id}
          />
        </div>
      )}
    </div>
  );
};

export default PaymentTab;
